export const pageUrl = {
  managementDashboard: '/management-dashboard',
  manifest: {
    landing: '/manifest',
    review: ({ batchId }: { batchId: string }): string => {
      return `/manifest/review/${batchId}`;
    },
    blReview: ({ batchId, id }: { batchId: string; id: number | null }): string => {
      const params = new URLSearchParams({
        ...((id && { id: id.toString() }) || {}),
      });
      return `/manifest/review/${batchId}/bl?${params.toString()}`;
    },
  },
  draftManifest: '/draft-manifest',
  historicalData: '/historical-data',
  reports: {
    bc20: '/report/bc-20',
    bc57: '/report/bc-57',
    bc30: '/report/bc-30',
  },
  seaCarriers: '/master/sea-carriers',
  docPabean: '/doc-pabean',
  draftDocPabean: '/doc-pabean/draft',
  docPabeanUpload: '/doc-pabean/upload',
  stampDuty: '/stamp-duty',
  fileCompression: '/file-compression',
  dashboard: '/dashboard',
  approval: {
    requests: '/customer-approval',
    emailGroups: '/customer-approval/email-groups',
    reviewers: '/customer-approval/reviewers',
    roles: '/customer-approval/roles',
    reviewerLogin: '/approval/login',
    reviewerDashboard: '/approval/dashboard',
    reviewerEmailGroups: '/approval/email-groups',
  },
  customerEmailForwarding: '/master/customer-email-forwarding',
  credit: {
    topup: '/credit/topup',
  },
  subscription: '/subscription',
  /** Published changelog. Intentionally not a sidebar menu entry — see the page. */
  riwayatPembaruan: '/riwayat-pembaruan',
  ppftz: {
    list: '/ppftz',
    create: '/ppftz/new',
    edit: (id: number | string): string => `/ppftz/${id}/edit`,
    fromProcess: '/ppftz/from-process',
  },
};

export const apiUrl = {
  login: '/api/v1/auth/login',
  cubeSso: {
    login: '/api/v1/auth/cube-sso/login',
  },
  dashboard: '/api/v1/dashboard/personal-dashboard',
  refreshToken: '/api/v1/auth/refresh-token',
  master: {
    customer: {
      list: '/api/v1/customers',
      detail: '/api/v1/customer',
    },
    port: {
      list: '/api/v1/ports',
    },
    country: {
      list: '/api/v1/countries',
    },
    hs: {
      list: '/api/v1/ceisa/uploads/get-all-hscode',
    },
    packages: {
      list: '/api/v1/packages',
    },
    gudangTps: {
      list: ({ officeCode }: { officeCode: string }): string => {
        const params = new URLSearchParams({
          ...((officeCode && { kodeKantor: officeCode }) || {}),
        });
        return `/api/v2/ceisa/uploads/gudang-tps?${params.toString()}`;
      },
    },
    pabeanOffice: {
      list: '/api/v1/pabean-offices',
      listv2: '/api/v1/pabean-offices/v2',
    },
    entity: {
      list: '/api/v1/ceisa/jarvis/entity',
    },
    seaCarriers: {
      uploadCsv: '/api/v1/sea-carriers/upload-csv',
    },
    /** Per-PPJK consignee (importir) master. Scoped server-side by the token's PPJK. */
    consignees: {
      base: '/api/v3/master/consignees',
      detail: (id: number) => `/api/v3/master/consignees/${id}`,
      template: '/api/v3/master/consignees/template',
      export: '/api/v3/master/consignees/export',
      import: '/api/v3/master/consignees/import',
      /** Every PPJK's consignees, read-only, super admins only (API-CONTRACT §9). */
      global: '/api/v3/master/consignees/global',
    },
    /** Per-PPJK exportir master (PEB Eksportir card). Scoped server-side by the token's PPJK. */
    eksportirs: {
      base: '/api/v3/master/eksportirs',
      detail: (id: number) => `/api/v3/master/eksportirs/${id}`,
      template: '/api/v3/master/eksportirs/template',
      export: '/api/v3/master/eksportirs/export',
      import: '/api/v3/master/eksportirs/import',
      /** Every PPJK's exportirs, read-only, super admins only. */
      global: '/api/v3/master/eksportirs/global',
    },
  },
  manifest: {
    create: '/api/v1/ceisa/uploads/draft-manifest-outward',
    uploadDraftBL: '/api/v1/ceisa/uploads/draft-manifest-bl',
    uploadExcelDraft: '/api/v1/nvocc-manifest/upload-excel-draft',
    submitDraftOutward: '/api/v1/ceisa/uploads/manifest/upload-draft-outward',
    list: '/api/v1/ceisa/edit/manifest/list',
    detailHeader: '/api/v1/ceisa/edit/manifest/header',
    blList: '/api/v1/ceisa/edit/manifest/list-bl',
    blDetail: ({ batchId, id }: { batchId: string | null; id: string | null }): string => {
      const params = new URLSearchParams({
        ...((id && { id: id }) || {}),
      });
      return `/api/v1/ceisa/edit/manifest/bl/${batchId}?${params.toString()}`;
    },
    deleteManifest: ({ batch }: { batch: string | null }): string => {
      const params = new URLSearchParams({
        ...((batch && { batch: batch }) || {}),
      });
      return `/api/v1/ceisa/edit/manifest/header?${params.toString()}`;
    },
    deleteManifestBl: ({ id }: { id: number | null }): string => {
      const params = new URLSearchParams({
        ...((id && { id: id.toString() }) || {}),
      });
      return `/api/v1/ceisa/edit/manifest/bl?${params.toString()}`;
    },
    updateManifestBL: '/api/v1/ceisa/edit/manifest/bl',
    updateManifestHeader: '/api/v1/ceisa/edit/manifest/header',
    deleteManifestHsDetail: ({ id }: { id: number | null }): string => {
      const params = new URLSearchParams({
        ...((id && { id: id.toString() }) || {}),
      });
      return `/api/v1/ceisa/edit/manifest/hs-detail?${params.toString()}`;
    },
    deleteManifestContainerDetail: ({ id }: { id: number | null }): string => {
      const params = new URLSearchParams({
        ...((id && { id: id.toString() }) || {}),
      });
      return `/api/v1/ceisa/edit/manifest/container-detail?${params.toString()}`;
    },
    deleteManifestDocumentDetail: ({ id }: { id: number | null }): string => {
      const params = new URLSearchParams({
        ...((id && { id: id.toString() }) || {}),
      });
      return `/api/v1/ceisa/edit/manifest/document-detail?${params.toString()}`;
    },
  },
  report: {
    bc20: '/api/v1/ceisa/uploads/get-zip-data',
    bc20WithoutNpwp: '/api/v1/ceisa/uploads/get-zip-data-import',
    bc57: '/api/v1/ceisa/uploads/get-zip-data-bc57',
    bc30: '/api/v1/ceisa/uploads/get-zip-data-export',
  },
  companyEnrichment: {
    // Any signed-in user may report a wrong or missing company logo from the
    // document table. Reports are queued for review in the CMS rather than
    // applied directly: company_profiles is shared across every PPJK.
    feedback: '/api/v1/company-enrichment/feedback',
  },
  docPabean: {
    list: '/api/v2/ceisa/uploads/get-document-list',
    branchNames: '/api/v1/ceisa/uploads/branch-names',
    uploadExcelCeisa: (batchUUID: string) => `/api/v1/ceisa/uploads/upload-excel-by-uuid/${batchUUID}`,
    delete: (id: number) => `/api/v1/ceisa/uploads/document/${id}`,
    restore: (id: number) => `/api/v1/ceisa/uploads/document/${id}/restore`,
  },
  draft: {
    list: '/api/v2/ceisa/edit/draft',
  },
  ceisa: {
    /** Upsert of the caller's PPJK Pernyataan (one active row per PPJK). */
    statementConfigMe: '/api/v1/ceisa/uploads/statement-configs/me',
    customerEmailForwarding: {
      list: '/api/v1/ceisa/uploads/customer-email-forwarding',
      detail: (id: number) => `/api/v1/ceisa/uploads/customer-email-forwarding/${id}`,
      toggle: (id: number) => `/api/v1/ceisa/uploads/customer-email-forwarding/${id}/toggle`,
      recipients: (configId: number) => `/api/v1/ceisa/uploads/customer-email-forwarding/${configId}/recipients`,
      recipient: (configId: number, recipientId: number) =>
        `/api/v1/ceisa/uploads/customer-email-forwarding/${configId}/recipients/${recipientId}`,
      recipientToggle: (configId: number, recipientId: number) =>
        `/api/v1/ceisa/uploads/customer-email-forwarding/${configId}/recipients/${recipientId}/toggle`,
    },
  },
  rbac: {
    // Effective permissions + menu access for the signed-in user.
    me: '/api/v1/rbac/me',
    permissions: '/api/v1/rbac/permissions',
    menus: '/api/v1/rbac/menus',
    roles: '/api/v1/rbac/roles',
    role: (id: number) => `/api/v1/rbac/roles/${id}`,
    roleUsers: (id: number) => `/api/v1/rbac/roles/${id}/users`,
    subjects: '/api/v1/rbac/subjects',
  },
  users: {
    /**
     * The caller's own UI settings. Any logged-in user may read and write
     * these — it is not part of the admin user surface.
     */
    mePreferences: '/api/v1/users/me/preferences',
    /** First-login onboarding state for the signed-in user. */
    meOnboarding: '/api/v1/users/me/onboarding',
  },
  patchLogs: {
    unread: '/api/v1/patch-logs/unread',
    acknowledge: '/api/v1/patch-logs/acknowledge',
    defer: '/api/v1/patch-logs/defer',
    published: '/api/v1/patch-logs/published',
  },
  approval: {
    importirs: '/api/v1/approval/importirs',
    emailGroups: '/api/v1/approval/email-groups',
    emailGroup: (id: number) => `/api/v1/approval/email-groups/${id}`,
    emailGroupEmails: (id: number) => `/api/v1/approval/email-groups/${id}/emails`,
    emailGroupEmail: (groupId: number, emailId: number) => `/api/v1/approval/email-groups/${groupId}/emails/${emailId}`,
    emailGroupEmailToggle: (groupId: number, emailId: number) =>
      `/api/v1/approval/email-groups/${groupId}/emails/${emailId}/toggle`,
    reviewers: '/api/v1/approval/reviewers',
    reviewer: (id: number) => `/api/v1/approval/reviewers/${id}`,
    reviewerToggle: (id: number) => `/api/v1/approval/reviewers/${id}/toggle`,
    requests: '/api/v1/approval/requests',
    requestDetail: (id: number) => `/api/v1/approval/requests/${id}`,
    requestResend: (id: number) => `/api/v1/approval/requests/${id}/resend`,
    requestCancel: (id: number) => `/api/v1/approval/requests/${id}/cancel`,
    reviewerLogin: '/api/v1/approval/reviewer/login',
    reviewerRequests: '/api/v1/approval/reviewer/requests',
    reviewerRequestDetail: (uuid: string) => `/api/v1/approval/reviewer/requests/${uuid}`,
    reviewerRequestPdf: (uuid: string) => `/api/v1/approval/reviewer/requests/${uuid}/pdf`,
    reviewerApprove: (uuid: string) => `/api/v1/approval/reviewer/requests/${uuid}/approve`,
    reviewerNeedRevision: (uuid: string) => `/api/v1/approval/reviewer/requests/${uuid}/need-revision`,
    requestChecklistToggle: (id: number, itemId: number) =>
      `/api/v1/approval/requests/${id}/checklist/${itemId}/toggle`,
  },
  credit: {
    topup: '/api/v1/payment/durianpay/topup',
    balance: (accountCode: string) => `/api/v1/ppjk-credits/balances/${accountCode}`,
    balanceByProduct: (accountCode: string, productCode: string) =>
      `/api/v1/ppjk-credits/balances/${accountCode}/${productCode}`,
    products: '/api/v1/ppjk-credits/products',
  },
  companyFeatures: {
    me: '/api/v1/company-features/me',
  },
  companySettings: {
    /**
     * The caller's own company policy. Readable by every member — the upload
     * screen needs it — but writable only with `rbac:manage`.
     */
    me: '/api/v1/company-settings/me',
  },
  companyReference: {
    me: '/api/v1/company-reference/me',
    options: '/api/v1/company-reference/options',
  },
  subscription: {
    me: '/api/v1/subscriptions/me',
    cancelMy: '/api/v1/subscriptions/me/cancel',
    plans: '/api/v1/subscriptions/plans',
    myPlans: '/api/v1/subscriptions/me/plans',
    subscribe: '/api/v1/subscriptions/subscribe',
    myInvoices: ({ status, limit, offset }: { status?: string; limit?: number; offset?: number } = {}): string => {
      const params = new URLSearchParams({
        ...((status && { status }) || {}),
        ...((limit !== undefined && { limit: limit.toString() }) || {}),
        ...((offset !== undefined && { offset: offset.toString() }) || {}),
      });
      const query = params.toString();
      return `/api/v1/subscriptions/me/invoices${query ? `?${query}` : ''}`;
    },
    payInvoice: (invoiceId: number, paymentType: string) =>
      `/api/v1/subscriptions/invoices/${invoiceId}/pay?payment_type=${paymentType}`,
    invoicePdf: (invoiceId: number) => `/api/v1/subscriptions/invoices/${invoiceId}/pdf`,
  },
  paymentFee: {
    /**
     * Prices the MDR for one amount without creating anything, so a checkout
     * can show the fee before the customer commits. The backend owns the
     * arithmetic on purpose — a formula duplicated here would drift from the
     * figure the customer is actually charged.
     */
    quote: ({ scope, method, amount }: { scope: string; method: string; amount: number }): string =>
      `/api/v1/payment-fee-rates/quote?${new URLSearchParams({
        scope,
        method,
        amount: String(amount),
      }).toString()}`,
  },
  notifications: {
    /**
     * Incoming CEISA email responses for the signed-in user's forwarder. The
     * API resolves the PPJK from the session, so the NPWP is never a
     * parameter here — passing one would not widen what comes back.
     */
    emailResponses: ({ limit, offset }: { limit?: number; offset?: number } = {}): string => {
      const params = new URLSearchParams({
        ...((limit !== undefined && { limit: String(limit) }) || {}),
        ...((offset !== undefined && { offset: String(offset) }) || {}),
      });
      const query = params.toString();
      return `/api/v1/notifications/email-responses${query ? `?${query}` : ''}`;
    },
    emailResponsesUnreadCount: '/api/v1/notifications/email-responses/unread-count',
    // static sibling of /email-responses/:id/read would conflict in gin's
    // route tree, hence the dashed path
    emailResponsesReadAll: '/api/v1/notifications/email-responses/read-all',
    emailResponseRead: (id: number): string => `/api/v1/notifications/email-responses/${id}/read`,
    emailResponseAttachment: (id: number, index: number): string =>
      `/api/v1/notifications/email-responses/${id}/attachments/${index}/download`,
  },
  ppftz: {
    references: '/api/v1/ceisa/ppftz/references',
    suggestAju: '/api/v1/ceisa/ppftz/aju/suggest',
    documents: '/api/v1/ceisa/ppftz/documents',
    // static sibling of /documents/:id would conflict in gin's route tree,
    // hence the dashed path
    documentsFromProcess: '/api/v1/ceisa/ppftz/documents-from-process',
    document: (id: number | string): string => `/api/v1/ceisa/ppftz/documents/${id}`,
    documentSection: (id: number | string, section: string): string => `/api/v1/ceisa/ppftz/documents/${id}/${section}`,
    payload: (id: number | string): string => `/api/v1/ceisa/ppftz/documents/${id}/payload`,
    history: (id: number | string): string => `/api/v1/ceisa/ppftz/documents/${id}/history`,
    check: (id: number | string): string => `/api/v1/ceisa/ppftz/documents/${id}/check`,
    submit: (
      id: number | string,
      { isFinal, isRevision }: { isFinal?: boolean; isRevision?: boolean } = {}
    ): string => {
      const params = new URLSearchParams({
        ...((isFinal !== undefined && { isFinal: String(isFinal) }) || {}),
        ...((isRevision !== undefined && { isRevision: String(isRevision) }) || {}),
      });
      const query = params.toString();
      return `/api/v1/ceisa/ppftz/documents/${id}/submit${query ? `?${query}` : ''}`;
    },
    status: (id: number | string): string => `/api/v1/ceisa/ppftz/documents/${id}/status`,
    formulir: (id: number | string, type: 'draft' | 'final'): string =>
      `/api/v1/ceisa/ppftz/documents/${id}/formulir?type=${type}`,
  },
};
